const key = "add-readonly-trigger";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/4$/);
};

const ruleJson = (validFieldId, readonlyFieldId) => ({
	"Id": 2,
	"Title": "Readonly Trigger",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 4,
		"Code": "REQUIRED",
		"Name": "Required"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Field":
			{
				"Id": validFieldId
			}
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 50,
				"Code": "READONLY",
				"Name": "Make Field Readonly"
			},
			"Type":
			{
				"Id": 1,
				"Code": "USERINTERFACE",
				"Name": "User Interface"
			},
			"Field": {
				"Id": readonlyFieldId
			},
			"Matched": "ENABLE",
			"NotMatched": "DISABLE"
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules) {
		return;
	}

	const ruleWithUnknownTrigger = ruleJson(68, 69);
	resp.data.Data.Rules.push(ruleWithUnknownTrigger);
};

export const addReadonlyTrigger = [key, applicable, modify];